$(document).ready(function () {
    _filterInfo.Initialize();
});

_filterInfo = {
    ready: false,
    totalResults: null,
    currentFilters: {},

    Initialize: function () {
        if (!$("[data-filters]").length) return; // don't bother executing filter code, no filtering on page

        //collect the preset values from query strings
        var queryData = GetQueryInfo();

        this.SortResults("date-asc");
        this.UpdateFilterListItems();
        this.UpdateFilterResultCount();
        this.SetupFilterBindings();
        this.ready = true;
        this.AddPresetValues(queryData);
    },

    AddPresetValues: function (queryData) {

        for (var wrapper in queryData) {
            var qList = queryData[wrapper];
            //validate the preset values before adding the filter
            var $filterWrapper = $(".filter-list-wrapper[data-shared-name='" + wrapper + "' i]");
            var listname = $filterWrapper.attr("name").trim();

            if ($filterWrapper.length) {
                var $filterOptions = $filterWrapper.find(".filter-list li");

                //

                if ($filterOptions.length) {
                    for (var q in qList) {
                        var qListValue = qList[q];

                        var splitValues = qListValue.split(",");

                        for (var sv in splitValues) {
                            var splitListValue = splitValues[sv];

                            //add each preset value
                            $filterOptions.each(function () {
                                var filterText = $(this).text().trim();
                                var sharedValue = $(this).attr("data-shared-key").trim();
                                if (sharedValue.toLowerCase() == splitListValue.toLowerCase()) {
                                    var filterValue = $(this).val() + "";
                                    _filterInfo.AddFilter(listname, filterValue, filterText, sharedValue, wrapper);
                                }
                            });
                        }
                    }
                }
            }
        }

    },

    SetupFilterBindings: function () {
        //list bindings - add or remove
        $(".filter-list li").on("click", function () {
            var $this = $(this);
            var value = $this.attr("value").trim();

            if (value == "0" || $this.hasClass("disabled")) {
                return; //short circuit disabled items
            }

            var sharedlistname = $this.closest(".filter-list-wrapper").attr("data-shared-name").trim();
            var text = $this.find(".filter-text").text().trim();
            var shared = $this.attr("data-shared-key").trim();
            var listname = $this.closest(".filter-list-wrapper").attr("name").trim();

            if ($this.hasClass('selected')) {
                _filterInfo.RemoveFilter(listname, value, text);
            } else {
                _filterInfo.AddFilter(listname, value, text, shared, sharedlistname);
            }
        });

        //pill bindings - remove only
        $(".filter-pill-section").on("click", ".filter-pill:not(.remove-all)", function () {
            var $this = $(this);
            var value = $this.attr("value").trim();
            var text = $this.text().trim();
            var listname = $this.attr("list").trim();
            _filterInfo.RemoveFilter(listname, value, text);
        });


        $('body').click(function (evt) {
            if ($(evt.target).closest(".filter-select li").length > 0) {
                return false;
            }
            $(".filter-select li").removeClass("active");

            // click anywhere other than filter-select will hide filters.
            var $filterList = $(".filter-select li ul");

            $filterList.css("visibility", "hidden");
            $filterList.css("opacity", "0");
            $filterList.css("display", "none");

        });

        $(".filters-popup-backdrop, .filters-popup-close").on("click", function (evt) {
            $(".filters-popup").removeClass("active");
            $(".filters-popup-backdrop").hide();
        });

        $(".filters-popup .filter-list-wrapper .filter-type-name").on("click", function (evt) {
            var $filterTypeName = $(this);
            $filterTypeName.toggleClass("closed").toggleClass("opened");

            if ($filterTypeName.hasClass("closed")) {
                $filterTypeName.siblings(".filter-list").hide();
            } else {
                $filterTypeName.siblings(".filter-list").show();
            }
        });

        $(".filter-select .filter-type-wrapper").on("click", function () {
            var $filterTypeWrapper = $(this);
            var sharedListName = $filterTypeWrapper.attr("data-shared-name").trim();
            var $filterListWrapper = $(".filters-popup .filter-list-wrapper[data-shared-name='" + sharedListName + "']");

            $(".filters-popup").addClass("active");
            $(".filters-popup-backdrop").show();

            $(".filters-popup .filter-list-wrapper .filter-type-name").removeClass("opened").addClass("closed");
            $(".filters-popup .filter-list-wrapper .filter-list").hide();

            $filterListWrapper.find(".filter-type-name").removeClass("closed").addClass("opened");
            $filterListWrapper.find(".filter-list").show();
        });

        $(".remove-all").on("click", function () {
            _filterInfo.ResetFilters();
        });

        $(".filter-word-wrap").on("click", function () {
            if (BreakpointDetection.is('xs') === true || BreakpointDetection.is('sm') === true) {
                $(".filter-select").toggleClass("show-filter-mobile");
                $(".filter-word-wrap").toggleClass("active");
            }
        });



        //pagination bindings 
        $(".resource-number-wrap").on("click", function () {
            var $this = $(this);
            if ($this.hasClass("active") || $this.hasClass("disable")) {
                return;
            }

            var targetPage = $this.attr("data-page-target");
            _filterInfo.SetupPagination(parseInt(targetPage));
        });

        $(".resource-previous-button").on("click", function () {
            var $this = $(this);
            if ($this.hasClass("disable")) {
                return;
            }

            var targetPage = $(".resource-number-wrap.active").attr("data-page-target");
            _filterInfo.SetupPagination(parseInt(targetPage) - 1);
        });

        $(".resource-next-button").on("click", function () {
            var $this = $(this);
            if ($this.hasClass("disable")) {
                return;
            }

            var targetPage = $(".resource-number-wrap.active").attr("data-page-target");
            _filterInfo.SetupPagination(parseInt(targetPage) + 1);
        });

        $(".resource-last-button, .resource-first-button").on("click", function () {
            var $this = $(this);
            if ($this.hasClass("disable")) {
                return;
            }

            var targetPage = $this.attr("data-page-target");
            _filterInfo.SetupPagination(parseInt(targetPage));
        });

        $(".sort-by-word").on('click', function () {

            if ($(this).hasClass("up")) {
                //hide ascending sort
                $(".sort-by-word").removeClass("up");

                //show descending sort
                $(".sort-by-word").addClass("down");
                _filterInfo.SortResults("date-desc");
            } else {
                //hide descending sort
                $(".sort-by-word").removeClass("down");

                //show ascending sort
                $(".sort-by-word").addClass("up");
                _filterInfo.SortResults("date-asc");
            }
        });
    },

    ResetFilters: function () {
        $(".filter-pill:not(.remove-all)").remove();
        $(".filter-list li").removeClass("selected").removeClass("disabled");

        this.currentFilters = {};
        this.UpdateFilterResults();
    },

    RemoveFilter: function (listname, value, filtername, $pill) {
        if (typeof $pill == 'undefined') {
            $pill = null;
        }

        if (!this.currentFilters[listname]) {
            return; // defensive coding, should never hit this case
        }

        var targetList = this.currentFilters[listname];

        for (var i = targetList.length; i--;) {
            if (targetList[i].value == value) {
                targetList.splice(i, 1);
                break;
            }
        }

        if (!$pill) {
            $pill = $(".filter-pill-section .filter-pill[value='" + value + "']");
        }

        $pill.remove();
        var $filterListItem = $(".filter-list li[value='" + value + "']").removeClass("selected");

        this.UpdateFilterResults();
    },

    AddFilter: function (listname, value, filtername, shared, sharedlist) {
        if (!this.currentFilters[listname]) {
            this.currentFilters[listname] = [];
        }

        if (this.currentFilters[listname].find(item =>
            item.value === value &&
            item.shared === shared &&
            item.sharedlist === sharedlist
        )) {
            return;
        }

        this.currentFilters[listname].push({ value, shared, sharedlist });

        var $newPill = `<span class="button-default filter-pill filter-tag" value="` + value + `" list="` + listname + `">` + filtername + `</span>`;
        $(".filter-pill-section .remove-all").before($newPill);
        var $filterListItem = $(".filter-list li[value='" + value + "']").addClass("selected");

        this.UpdateFilterResults();
    },

    SortResults: function (sortType) {
        //collect all of the filters
        var $maxSet = $("[data-filters]");
        var list = $maxSet.get(); //array elements to allow for sorting

        if (!this.ready) {
            if ($maxSet.filter("[data-date]").length) {
                $(".sort-by-word").show();
            } else {
                return; //no need to sort
            }
        }

        switch (sortType) {
            case "date-asc":
                list.sort(DateSortAsc);
                break;
            case "date-desc":
                list.sort(DateSortDesc);
                break;
            case "title-asc":
                list.sort(TitleSortAsc);
                break;
            case "title-desc":
                list.sort(TitleSortDesc);
                break;
            default: break;
        }

        //replace elements in the correct order
        for (var i = 0; i < list.length; i++) {
            list[i].parentNode.appendChild(list[i]);
        }


        //sort change visible elements - pagination needs to be re-initialized
        this.SetupPagination();

        //data-date required on each element
        function DateSortAsc(bElem, aElem) {
            var a = new Date($(aElem).attr("data-date"));
            var b = new Date($(bElem).attr("data-date"));
            return a - b;
        }
        function DateSortDesc(aElem, bElem) {
            var a = new Date($(aElem).attr("data-date"));
            var b = new Date($(bElem).attr("data-date"));
            return a - b;
        }

        //sorts by inner text content
        function TitleSortAsc(bElem, aElem) {
            return bElem.innerHTML.toLowerCase().localeCompare(aElem.innerHTML.toLowerCase());
        }
        function TitleSortDesc(aElem, bElem) {
            return aElem.innerHTML.toLowerCase().localeCompare(bElem.innerHTML.toLowerCase());
        }
    },

    //handles all updates to the filter drop list items - count (update & loading), disable (update & loading), and removal (on loading only)
    UpdateFilterListItems: function () {
        if (this.totalResults == null) {
            this.totalResults = $("[data-filters]").length;
        }
        $(".filter-list li").each(function () {
            var $this = $(this);
            if (!$this.hasClass("selected")) {
                var value = $this.attr("value").trim();
                var shared = $this.attr("data-shared-key").trim();
                var $filterListWrapper = $this.closest(".filter-list-wrapper");
                var sharedListName = $filterListWrapper.attr("data-shared-name").trim();
                var listname = $filterListWrapper.attr("name").trim();

                var $filterTypeWrapper = $(".filter-type-wrapper[data-shared-name='" + sharedListName + "']");

                if (value == "0") {
                    return; //short circuit default case, don't do anything
                }

                //build fake filter info to calculate a fake result set
                var newFilterInfo = { list: listname, value: { value, shared } };
                var predictedResultSet = _filterInfo._CalculateFilterResults(newFilterInfo);

                var count = predictedResultSet.length;

                if (count == 0) {
                    if (!_filterInfo.ready) {
                        $this.remove();
                    } else {
                        $this.addClass("disabled");
                    }
                } else {
                    if (!_filterInfo.ready) {
                        $filterTypeWrapper.show();
                    }
                    $this.removeClass("disabled");
                }
            }
        });

        //sanitize the wrappers that no longer have inner elements - unused on this page, remove it
        $(".filter-list-wrapper").each(function () {
            var $this = $(this);
            var sharedListName = $this.attr("data-shared-name").trim();
            var $filterTypeWrapper = $(".filter-type-wrapper[data-shared-name='" + sharedListName + "']");
            if (!$this.find(".filter-list li").length) {
                $this.remove();
                $filterTypeWrapper.remove();
            }
        });

        //sanitize the select if it no longer has inner elements
        if (!$(".filter-select").children().length) {
            $(".filter-select").remove();
        }

        //use current filters to rebuild URL
        console.log("Filter Info: " + JSON.stringify(_filterInfo.currentFilters));
        const url = new URL(window.location);
        const searchParams = new URLSearchParams();

        for (var list in _filterInfo.currentFilters) {
            var optionGroup = _filterInfo.currentFilters[list];

            //make sure that the option group still has filters selected - defensive check
            if (optionGroup.length) {
                //iterate each option in group and start to build refined group
                for (var j = optionGroup.length; j--;) {
                    var option = optionGroup[j];
                    searchParams.append(option.sharedlist, option.shared);
                }
            }
        }

        url.search = searchParams.toString();
        window.history.replaceState({}, '', url);


        //if (typeof responsiveNormalizeHeight !== 'undefined' && typeof responsiveNormalizeHeight === 'function') {
        //    responsiveNormalizeHeight(".resource-list .card", false, true, ".card-body", true);
        //}
    },

    //handles all updates to the filter result listing items - show and hide the appropriate result items, update total count
    UpdateFilterResults: function () {
        var maxSet = $("[data-filters]");
        var targetResultSet = this._CalculateFilterResults();

        if (maxSet.length != targetResultSet.length) {
            $("[data-filters]").addClass("hide");
        }
        targetResultSet.removeClass("hide");

        if ($(".filter-pill:not(.remove-all)").length) {
            $(".remove-all").show();
            $(".filter-pill-count").text($(".filters-popup .filter-pill-section .filter-pill:not(.remove-all)").length);
            $(".filter-pill-selected").show();
        } else {
            $(".remove-all").hide();
            $(".filter-pill-selected").hide();
        }

        // Account for both filters AND search
        var visibleCount = $("[data-filters]").not(".hide").not(".resource-search-inactive").length;
        this.UpdateFilterResultCount(visibleCount);
        this.UpdateFilterListItems();
    },

    //updates the total results, if no results provided - uses max set
    UpdateFilterResultCount: function (totalResults) {
        if (typeof totalResults == 'undefined') {
            totalResults = null;
        }

        if (totalResults == null) {
            totalResults = $("[data-filters]").length;
        }

        this.totalResults = totalResults;
        $(".result-count").text(totalResults);

        //filter changed - pagination needs to be re-initialized
        this.SetupPagination();
    },

    SetupPagination: function (currentPage) {
        if (typeof currentPage == 'undefined') {
            currentPage = 0;
        }

        // if pagination controls are removed, remove the associated pagination
        if (!$(".resource-page-paging").length) return;

        //gather button resources and initialize
        var $buttons = $(".resource-number-wrap").removeClass("active").addClass("disable").hide();
        var pageSize = 12; //consider changing this per viewport size
        var totalPages = Math.ceil(this.totalResults / pageSize) - 1;

        if (totalPages >= 0) {

            //don't start moving the number system until the current page is past 2
            var startPage = 0;
            if (currentPage > 2) {
                startPage = currentPage - 2;
            }

            var targetLastPage = startPage + 4;
            var lastPage = Math.min(targetLastPage, totalPages);

            //pages numbers are the same for the last 3 options
            if ((lastPage - startPage) <= 4) {
                startPage = lastPage - 4;
            }

            //handle prev and next button status
            if (currentPage >= totalPages) {
                $(".resource-next-button").addClass("disable");
                $(".resource-last-button").addClass("disable").removeClass("active");
            } else {
                $(".resource-next-button").removeClass("disable");
                $(".resource-last-button").removeClass("disable").addClass("active").attr("data-page-target", totalPages);
            }
            if (currentPage == 0) {
                $(".resource-previous-button").addClass("disable");
                $(".resource-first-button").addClass("disable").removeClass("active");
            } else {
                $(".resource-previous-button").removeClass("disable");
                $(".resource-first-button").removeClass("disable").addClass("active").attr("data-page-target", 0);
            }

            for (var i = 0; i < 5; i++) {
                var textNumber = i + startPage + 1;
                var pageIndex = i + startPage; //offset pages by current start page
                var $button = $buttons.eq(i); //get the current button we are working with

                if (textNumber <= 0) {
                    continue;
                }

                //initalize the button state
                $button.attr("data-page-target", pageIndex).removeClass("disable").find(".page-num").text(textNumber);
                $button.show();
                if (pageIndex == currentPage) {
                    $button.addClass("active");
                }
            }

            //handle hiding and showing the results
            var $resultItems = $("[data-filters]").not(".hide").not(".resource-search-inactive").addClass("page-hide");
            var startItem = currentPage * pageSize;
            var endItem = Math.min(startItem + pageSize, this.totalResults);
            for (var i = startItem; i < endItem; i++) {
                $resultItems.eq(i).removeClass("page-hide");
            }
        }
    },

    //calculates the result of the merge before actually making any changes to the DOM. allows for predicting the results of a future set change
    _CalculateFilterResults: function (newFilterInfo) {
        if (typeof newFilterInfo == 'undefined') {
            newFilterInfo = null;
        }

        if (newFilterInfo != null) {
            var hadPrevFilter = false;
            //cloned filters - calculating filter information only - not real updates
            var clonedFilters = JSON.parse(JSON.stringify(_filterInfo.currentFilters));
            if (!clonedFilters[newFilterInfo.list] || !clonedFilters[newFilterInfo.list].length) {
                clonedFilters[newFilterInfo.list] = [];
            } else {
                hadPrevFilter = true;
            }
            clonedFilters[newFilterInfo.list] = [newFilterInfo.value]; //replace the existing information during look-ahead testing to see a difference only
            targetFilters = clonedFilters;
        } else {
            //use current filters - an update has occurred - real updates
            targetFilters = this.currentFilters;
        }

        var resultGroups = [];

        //iterate filter groups to combine "OR" logic within each group
        for (var list in targetFilters) {
            var optionGroup = targetFilters[list];

            //make sure that the option group still has filters selected - defensive check
            if (optionGroup.length) {
                var results = [];

                //iterate each option in group and start to build refined group
                for (var j = optionGroup.length; j--;) {
                    var option = optionGroup[j];

                    //initial get to quickly gather fuzzy matches
                    var resultSet = $("[data-filters*='" + option.value + "']").get();

                    //now that we have a reduced set, manually remove false-positives
                    if (resultSet.length > 1) {
                        for (var i = resultSet.length; i--;) {
                            var $resElem = $(resultSet[i]);
                            var rawDataFilter = $resElem.attr("data-filters");
                            var complexFind = rawDataFilter.split(",").indexOf(option.value);

                            //we have a false positive, remove it
                            if (complexFind == -1) {
                                resultSet.splice(i, 1);
                            }
                        }
                    }

                    results = results.concat(resultSet); // OR merge
                    $.uniqueSort(results);
                }

                resultGroups.push($(results));
            }
        }


        if (resultGroups.length) {
            var mergedResult = resultGroups[0];
            if (resultGroups.length > 1) {
                //we have multiple result groups - we need to merge
                //iterate filter result groups to combine "AND" logic across groups
                for (var k = 1; k < resultGroups.length; k++) {
                    var result = resultGroups[k];

                    mergedResult = mergedResult.filter(result); // AND merge
                }
            }

            //if we had a previous filter in this group, then we need to calculate the difference between the result set
            if (hadPrevFilter) {
                var currentResults = $("[data-filters]").not(".hide");
                var currentResultsCount = currentResults.length;
                //mergedResult = mergedResult.filter(currentResults);
            }

            return mergedResult;
        } else {
            //no filters - show all
            return $("[data-filters]");
        }

    }
};